/* eslint import/prefer-default-export: off */

enum codes {
  CLEARWATER = '47',
  ONLINE = '45',
  UNKNOWN = 'UNSPEC',
}

export { codes }
